import React, { useEffect } from "react";
import { Navigate, Route } from "react-router-dom";
import { setAuthorization } from "../api";
import { useDispatch } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";
import { getUserRole } from "../helpers/role_helper";

import { logoutUser } from "../slices/auth/login/thunk";

const AuthProtected = (props) =>{
  const dispatch = useDispatch();
  const { userProfile, loading, token } = useProfile();
  
  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    } else if (!userProfile && loading && !token) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  /*
    Navigate is un-auth access protected routes via url
    */

  if (!userProfile && loading && !token) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  // Single requiredRole, or allowedRoles for routes shared by admin + seller (avoid duplicate Route match issues)
  if (userProfile && (props.requiredRole || props.allowedRoles)) {
    const userRole = getUserRole(userProfile);
    if (props.allowedRoles && Array.isArray(props.allowedRoles)) {
      if (!props.allowedRoles.includes(userRole)) {
        return <Navigate to={userRole === "seller" ? "/seller/dashboard" : "/dashboard"} />;
      }
    } else if (props.requiredRole && userRole !== props.requiredRole) {
      return <Navigate to={userRole === "seller" ? "/seller/dashboard" : "/dashboard"} />;
    }
  }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };